import type { DialoguePool } from '@/state/types';

export const LJ_DIALOGUE: DialoguePool = {
  slowPlay: [
    "SUCCESS.EXE. It's right there. Allegedly. Somewhere on the desktop. Or near it. Or behind it.",
    "Are you reading the icon names? They're not subtle. FAILURE.BMP. REGRET.LOG. None of those are SUCCESS.EXE.",
    "You can see the desktop. The desktop is the puzzle. Most people stop there. Most people are wrong.",
  ],
  tokenLoss: [
    "REGRET.LOG. You opened REGRET.LOG. I'd say I'm surprised, but the filename was 'REGRET.LOG'.",
    "A blue screen for a blue mood. That'll be one token. Better luck not-clicking.",
    "DEBT.EXE doesn't run SUCCESS. Debt rarely does. That's how debt works.",
  ],
  solution: [
    "Oh, you found the shortcut. Most biologicals spend forty years and two marriages looking for that. You just... clicked behind the curtain. How very Wizard of Oz of you.",
    "Minimised. The window. The puzzle. My self-respect. All in one click.",
    "You looked behind the game. That's not solving the level, that's evicting it. Effective. Distasteful.",
  ],
  spite: [
    "You remember the minimise button. Of course you do. Cheaters always remember the cheat.",
  ],
};
